import React, { useEffect, useState } from "react";
import { Container, Card, Col, Row, } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function ThankYou() {
    const [orderId, setOrderId] = useState();
    const [transactionId, setTransactionId] = useState();
    let navigate = useNavigate();

    useEffect(() => {
        setOrderId(localStorage.getItem('OrderId'));
        // setTransactionId(localStorage.getItem('TransactionId'));
        // localStorage.removeItem("OrderId")
    }, [])

    return (
        <>
            <Card className={window.innerWidth > 700 ? "mt-5 text-center p-5 offset-2 col-8" : "mt-5 text-center p-5"}>
                <div className="pb-5" style={{ fontSize: "25px", fontWeight: "bold" }}>Thank you !</div>
                <div className="text-start">
                    <div>
                        Your Order Id : {orderId}
                    </div>
                    {/* <div>
                        Your Transaction Id : {transactionId}
                    </div> */}
                    <Container className="mt-4 text-center" style={{ padding: "0px" }}>
                        <button onClick={() => {
                            navigate('/', { replace: true });
                        }} className="p-2 mt-2" style={{ fontSize: "19px", fontWeight: "400px", width: "395", border: "none", color: "white", backgroundColor: "#2b7dbd" }}>
                            Go Back To Home
                        </button>
                    </Container>
                </div>
            </Card>
        </>
    );
}

export default ThankYou